import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

(window as any)['pdfWorkerSrc4.8.69'] =
  '/assets/public/pdf.worker.min.mjs';

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
